module.exports = __webpack_public_path__ + "img/marker-icon.ca888007.svg";